// Vendor Imports
import React, { Component } from 'react';

// Project Imports
import { I18n } from 'common/i18n';
import {
  doAnyFiltersHaveResettableChanges,
  resetAllFiltersToDefaults,
} from 'common/components/FilterBar/lib/allFilters';
import { SoqlFilter } from './SoqlFilter';
import { FilterBarColumns } from './index';
import { FilterBarColumn, FilterBarPendoIds } from './types';
import { DataSourceCCVs, FilterParameterConfiguration } from 'common/types/reportFilters';
import { ForgeButton } from '@tylertech/forge-react';

// Constants
const scope = 'shared.components.filter_bar';

export interface ResetFiltersButtonProps {
  clientContextVariables: DataSourceCCVs | undefined;
  columns: FilterBarColumns;
  computedColumns?: FilterBarColumn[];
  editMode: boolean;
  filterParameterConfigurations?: FilterParameterConfiguration[];
  isReadOnly?: boolean;
  onReset: (updated: SoqlFilter[]) => void;
  onResetAll: (updated: FilterParameterConfiguration[], clearAll?: boolean) => void;
  pendoIds?: FilterBarPendoIds;
}

export class ResetFiltersButton extends Component<ResetFiltersButtonProps> {
  onClick = () => {
    const {
      clientContextVariables,
      columns,
      computedColumns = [],
      editMode,
      filterParameterConfigurations,
      isReadOnly,
      onReset,
      onResetAll,
    } = this.props;
    if (filterParameterConfigurations) {
      const resetFilters = resetAllFiltersToDefaults(
        filterParameterConfigurations,
        columns,
        clientContextVariables,
        editMode,
        isReadOnly,
        computedColumns,
      );
      onResetAll(resetFilters, true);

      // This is needed for visualization & measures filters to be reset
      // with the onUpdate callback
      onReset(
        resetFilters.map((filter) => {
          return filter.config as SoqlFilter;
        }),
      );
    }
  };

  isDisabled = () => {
    const { clientContextVariables, editMode, filterParameterConfigurations, isReadOnly } = this.props;

    return !doAnyFiltersHaveResettableChanges(
      filterParameterConfigurations || [],
      editMode,
      clientContextVariables,
      isReadOnly,
    );
  };

  render() {
    const { pendoIds } = this.props;
    return (
      <div
        className="reset-filters"
        id={pendoIds?.resetAllFilters}
        data-testid="filter-bar-reset-all-filters"
      >
        <ForgeButton className="btn-reset-filters" disabled={this.isDisabled()} onClick={this.onClick}>
          {I18n.t('clear_all_filters', { scope })}
        </ForgeButton>
      </div>
    );
  }
}

export default ResetFiltersButton;
